import { LocalStorageKeys } from 'modules/shop/navigationManager/types';
import storage from 'modules/storage';

class GiftCardImagesManager {
  addStorageGiftCardImage(productReferenceKey: string, image: string) {
    return storage.local.setItem(LocalStorageKeys.giftCardImages, {
      [productReferenceKey]: image,
    });
  }

  removeStorageGiftCardImages() {
    return storage.local.removeItem(LocalStorageKeys.giftCardImages);
  }

  getRelevantGiftCardImage(productReferenceKey: string = '') {
    if (!productReferenceKey) {
      return;
    }

    const giftCardImages = storage.local.getItem(
      LocalStorageKeys.giftCardImages,
    );

    return giftCardImages?.[productReferenceKey];
  }
}

const giftCardImagesManager = new GiftCardImagesManager();

export default giftCardImagesManager;
